import {
  Autocomplete,
  Button,
  Dialog,
  DialogTitle,
  FormControlLabel,
  FormHelperText,
  InputAdornment,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid2";
import AddIcon from "@mui/icons-material/Add";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import PercentIcon from "@mui/icons-material/Percent";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import IconButton from "@mui/material/IconButton";
import { PageGroupEndPointLogic } from "../../../../../logic/AssetManagement/PageGroups/pageGroupEndPointLogic";
import { useSelector } from "react-redux";
import {
  selectUserToken,
  setDisplayErrorSnackBar,
} from "../../../../../features/userSlice";
import { MetaEntitiesEndPointLogic } from "../../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";
import { trackPromise } from "react-promise-tracker";
import { v4 as uuidv4 } from "uuid";
import CircularProgress from "@mui/material/CircularProgress";
import SaveIcon from "@mui/icons-material/Save";
import ClearIcon from "@mui/icons-material/Clear";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  buildComparisonTablesPayload,
  buildTrafficSourcesPayload,
  hasData,
  isComparisonTableListValid,
  isTrafficSourceListValid,
  buildFilteredPayload,
} from "./pageGroupHelpers";
import store from "../../../../../store";
import { restoreOriginalState, restoreUnlinkedItem } from "./pageGroupHelpers";
import RestoreIcon from "@mui/icons-material/Restore";
import ConfirmDialog from "../../../../CommonConfirmDialog/ConfirmDialog";

interface EditNewRequestModalProps {
  open: boolean;
  handleClose: () => void;
  selectedSiteUid: string;
  singlePageGroupData: any;
  setTableRefresh: any;
  setSnackbarOpen: any;
  loadingForEditModal: boolean;
  singlePageGroup: any;
  setSinglePageGroup: any;
}

function EditNewRequestModal({
  open,
  handleClose,
  setTableRefresh,
  loadingForEditModal,
  singlePageGroup,
  setSinglePageGroup,
}: EditNewRequestModalProps) {
  const [themeProportion, setThemeProportion] = useState(100);
  const [popupProportion, setPopupProportion] = useState(100);
  const [groupName, setGroupName] = useState(""); // Store the group name
  const [, setIsDuplicateButtonDisabled] = useState(true);
  const [currentPage, setCurrentPage] = useState(1); // Track the current page
  const token = useSelector(selectUserToken);
  const [themeList, setThemeList] = useState([]);
  const [popUpList, setPopUpList] = useState([]);
  const [trafficSources, setTrafficSources] = useState([]);
  const [popupSharedUid, setPopupShareUid] = useState("");
  const [themeSharedUid, setThemeShareUid] = useState("");
  const [selectedTheme1, setSelectedTheme1] = useState(null);
  const [selectedTheme2, setSelectedTheme2] = useState(null);
  const [selectedPopup1, setSelectedPopup1] = useState(null);
  const [selectedPopup2, setSelectedPopup2] = useState(null);
  const [autocompleteList, setAutocompleteList] = useState([
    { id: uuidv4() },
  ]) as any;
  const [autocompleteListCompTable, setAutocompleteListCompTable] = useState([
    { id: uuidv4() },
  ]) as any;
  const [, setWebsiteAttributeDetails] = useState([]) as any;
  const [uploadingDevice, setUploadingDevice] = useState("");
  const [imagePath, setImagePath] = useState("");
  const [loading, setLoading] = useState(false);
  const [creationLoading, setCreationLoading] = useState(false);
  const [initialTheme, setInitialTheme] = useState([]);
  const [initialPopup, setInitialPopup] = useState([]);
  const { selectedSharedUid } = useSelector((state: any) => state.pageGroup);
  const [showSecondTheme, setShowSecondTheme] = useState(false);
  const [showSecondPopup, setShowSecondPopup] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    type: "", // "table" or "source"
    index: null as number | null,
  });

  useEffect(() => {
    if (singlePageGroup) {
      setGroupName(singlePageGroup.group_name);
      const newThemeData = singlePageGroup.themes.map((theme: any) => ({
        id: uuidv4(),
        shared_uid: theme.shared_uid,
        name: theme.name,
        version: theme.version,
      }));
      const restructuredThemeData = newThemeData.map(
        ({ id, ...rest }: { id: string; [key: string]: any }) => rest,
      );
      setInitialTheme(newThemeData);
      setThemeShareUid(restructuredThemeData);
      if (newThemeData.length > 0) {
        setSelectedTheme1(newThemeData[0]); // Select the first theme by default
      }
      if (newThemeData.length > 1) {
        setShowSecondTheme(true);
        setSelectedTheme2(newThemeData[1]); // Select the second theme if available
      } else {
        setShowSecondTheme(false);
      }

      if (
        newThemeData[1] &&
        (newThemeData[1].shared_uid || newThemeData[1].name)
      ) {
        setShowSecondTheme(true);
        setThemeProportion(100 - themeProportion); // Set the proportion for the second theme
      } else {
        setShowSecondTheme(false);
      }

      const newPopupData = singlePageGroup.popups.map((popup: any) => ({
        id: uuidv4(),
        version: popup.version,
        shared_uid: popup.shared_uid,
        name: popup.name,
      }));
      const restructuredPopupData = newPopupData.map(
        ({ id, ...rest }: { id: string; [key: string]: any }) => rest,
      );
      setInitialPopup(newPopupData);
      setPopupShareUid(restructuredPopupData);

      if (newPopupData.length > 0) {
        setSelectedPopup1(newPopupData[0]); // Select the first theme by default
      }
      if (newPopupData.length > 1) {
        setShowSecondPopup(true);
        setSelectedPopup2(newPopupData[1]); // Select the second theme if available
      } else {
        setShowSecondPopup(false);
      }

      if (
        newPopupData[1] &&
        (newPopupData[1].shared_uid || newPopupData[1].name)
      ) {
        setShowSecondPopup(true);
        setPopupProportion(100 - popupProportion); // Set the proportion for the second theme
      } else {
        setShowSecondPopup(false);
      }

      // const comparisonTablesLength = singlePageGroup.comparison_tables.length;
      const newAutocompleteList = singlePageGroup.comparison_tables
        // .filter((table: any) => table.active) // Only show active tables
        .map((table: any) => ({
          id: uuidv4(),
          shared_uid: table.shared_uid,
          table: table.table,
          active: table.active,
          from_date: table.from_date ? dayjs(table.from_date) : dayjs(),
          to_date: table.to_date ? dayjs(table.to_date) : dayjs("2099-12-31"),
          page_group_to_comparison_table_shared_uid:
            table.page_group_to_comparison_table_shared_uid,
          isExisting: true, // Mark as existing item
          original_shared_uid: table.shared_uid, // Store original shared_uid
          original_from_date: table.from_date,
          original_to_date: table.to_date,
          original_table_name: table.table,
          selectedValue: {
            shared_uid: table.shared_uid,
            widget_name: table.table,
            table: table.table,
          },
        }));
      setAutocompleteListCompTable(
        newAutocompleteList.length > 0 ? newAutocompleteList : [],
      );

      const newTrafficSources = singlePageGroup.traffic_sources
        // .filter((source: any) => source.active) // Only show active sources
        .map((source: any) => ({
          id: uuidv4(),
          shared_uid: source.shared_uid,
          source: source.source,
          active: source.active,
          from_date: source.from_date ? dayjs(source.from_date) : dayjs(),
          to_date: source.to_date ? dayjs(source.to_date) : dayjs("2099-12-31"),
          page_group_to_traffic_source_shared_uid:
            source.page_group_to_traffic_source_shared_uid,
          isExisting: true, // Mark as existing item
          original_shared_uid: source.shared_uid, // Store original shared_uid
          original_from_date: source.from_date,
          original_to_date: source.to_date,
          original_source_name: source.source,
          selectedValue: {
            shared_uid: source.shared_uid,
            traffic_source_name: source.source,
            source: source.source,
          },
        }));
      setAutocompleteList(
        newTrafficSources.length > 0 ? newTrafficSources : [],
      );
      // Initialize headlines
      setHeadlineState({
        desktop: singlePageGroup.headlines?.desktop ? "custom" : "inherit",
        mobile: singlePageGroup.headlines?.mobile ? "custom" : "inherit",
        tablet: singlePageGroup.headlines?.tablet ? "custom" : "inherit",
      });

      setHeadlineCustomValue({
        desktop: singlePageGroup.headlines?.desktop || "",
        mobile: singlePageGroup.headlines?.mobile || "",
        tablet: singlePageGroup.headlines?.tablet || "",
      });
      // Initialize banners
      setbannerState({
        desktop: singlePageGroup.banners?.desktop ? "custom" : "inherit",
        mobile: singlePageGroup.banners?.mobile ? "custom" : "inherit",
        tablet: singlePageGroup.banners?.tablet ? "custom" : "inherit",
      });

      setBannerImagePathDesktop(singlePageGroup.banners?.desktop || "");
      setBannerImagePathMobile(singlePageGroup.banners?.mobile || "");
      setBannerImagePathTablet(singlePageGroup.banners?.tablet || "");
    }
    setThemeProportion(singlePageGroup?.theme_v1_proportions || 100);
    setPopupProportion(singlePageGroup?.popup_v1_proportions || 100);

    // eslint-disable-next-line
  }, [singlePageGroup, open === true]);

  //Functions for theme Proportion dynamic field implementation starts here

  const getFilteredThemeOptions = (excludeTheme: any) => {
    return themeList.filter(
      (theme: any) => theme.shared_uid !== excludeTheme?.shared_uid,
    );
  };

  const getFilteredPopupOptions = (excludePopup: any) => {
    return popUpList
      ?.filter((popup: any) => popup.type === "Popup Offer" && popup?.active) // only "Popup Offer"
      .filter((popup: any) => popup.shared_uid !== excludePopup?.shared_uid); // exclude selected one
  };

  const handleThemeProportionChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = parseInt(e.target.value, 10);
    // Ensure value is between 0 and 100
    const clampedValue = Math.min(Math.max(value, 0), 100);
    setThemeProportion(clampedValue);

    // Show/hide second theme field based on proportion value
    setShowSecondTheme(clampedValue < 100);
  };

  const handlePopupProportionChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = parseInt(e.target.value, 10);
    // Ensure value is between 0 and 100
    const clampedValue = Math.min(Math.max(value, 0), 100);
    setPopupProportion(clampedValue);

    // Show/hide second popup field based on proportion value
    setShowSecondPopup(clampedValue < 100);
  };

  const addSecondTheme = () => {
    if (initialTheme.length === 1 && showSecondTheme) {
      const secondTheme = {
        id: uuidv4(),
        shared_uid: "",
        name: "",
        version: 2,
      };

      // Add to initial theme list
      const updatedThemes: any = [...initialTheme, secondTheme];
      setInitialTheme(updatedThemes);

      // Update the theme shared UIDs
      const restructuredThemeData = updatedThemes.map(
        ({ id, ...rest }: { id: string; [key: string]: any }, index: any) => ({
          ...rest,
          version: index + 1,
        }),
      );
      setThemeShareUid(restructuredThemeData);
    }
  };

  const addSecondPopup = () => {
    if (initialPopup.length === 1 && showSecondPopup) {
      const secondPopup = {
        id: uuidv4(),
        shared_uid: "",
        name: "",
        version: 2,
      };

      // Add to initial theme list
      const updatedPopups: any = [...initialPopup, secondPopup];
      setInitialPopup(updatedPopups);

      // Update the theme shared UIDs
      const restructuredPopupData = updatedPopups.map(
        ({ id, ...rest }: { id: string; [key: string]: any }, index: any) => ({
          ...rest,
          version: index + 1,
        }),
      );
      setPopupShareUid(restructuredPopupData);
    }
  };

  useEffect(() => {
    if (showSecondTheme) {
      addSecondTheme();
    } else if (initialTheme.length > 1) {
      // Remove second theme if it exists
      const updatedThemes = [initialTheme[0]];
      setInitialTheme(updatedThemes);

      const restructuredThemeData: any = updatedThemes.map(
        ({ id, ...rest }: { id: string; [key: string]: any }, index) => ({
          ...rest,
          version: index + 1,
        }),
      );
      setThemeShareUid(restructuredThemeData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showSecondTheme]);
  useEffect(() => {
    if (showSecondPopup) {
      addSecondPopup();
    } else if (initialPopup.length > 1) {
      // Remove second popup if it exists
      const updatedPopups = [initialPopup[0]];
      setInitialPopup(updatedPopups);

      const restructuredPopupData: any = updatedPopups.map(
        ({ id, ...rest }: { id: string; [key: string]: any }, index) => ({
          ...rest,
          version: index + 1,
        }),
      );
      setPopupShareUid(restructuredPopupData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showSecondPopup]);

  //Functions for theme Proportion dynamic field implementation ends here

  // Handle input change and validate the minimum 8 character condition
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setGroupName(value);
    setIsDuplicateButtonDisabled(value.length < 8); // Enable if 8+ characters
  };

  // Handle the "Next" button click
  const handleNext = () => {
    setCurrentPage(currentPage + 1); // Move to the next page
  };

  // Handle the "Back" button click
  const handleBack = () => {
    setCurrentPage(currentPage - 1); // Move to the previous page
  };

  useEffect(() => {
    if (open === true) {
      // static shared uids
      const popupSharedUid =
        selectedSharedUid === "fc32450a45d44ab1ac94e84b5de73f06"
          ? "b4ae9c184e884cee976d593ebda9fff3"
          : selectedSharedUid;

      Promise.all([
        PageGroupEndPointLogic.getAllThemes(
          token,
          selectedSharedUid,
          setThemeList,
        ),
        PageGroupEndPointLogic.getAllPopups(
          token,
          popupSharedUid,
          setPopUpList,
        ),
        MetaEntitiesEndPointLogic.getMetaTrafficSource(
          token,
          setTrafficSources,
          trackPromise,
        ),
        PageGroupEndPointLogic.getWebsiteAttributeDetails(
          token,
          selectedSharedUid,
          setWebsiteAttributeDetails,
        ),
      ]);
    }
    // eslint-disable-next-line
  }, [open]);

  const [headlineState, setHeadlineState] = useState({
    desktop: "inherit",
    mobile: "inherit",
    tablet: "inherit",
  }) as any;

  const [bannerState, setbannerState] = useState({
    desktop: "inherit",
    mobile: "inherit",
    tablet: "inherit",
  }) as any;

  const [headlineCustomValue, setHeadlineCustomValue] = useState({
    desktop: "",
    mobile: "",
    tablet: "",
  }) as any;

  const [base64Images, setBase64Images] = useState<{
    [key: string]: string | null;
  }>({
    desktop: null,
    mobile: null,
    tablet: null,
  }) as any;

  const [bannerImagePathDesktop, setBannerImagePathDesktop] = useState("");
  const [bannerImagePathMobile, setBannerImagePathMobile] = useState("");
  const [bannerImagePathTablet, setBannerImagePathTablet] = useState("");

  const handleHeadlineChange = (device: string, value: string) => {
    setHeadlineState((prevState: any) => ({
      ...prevState,
      [device]: value,
    }));
  };

  const handleBannerChange = (device: string, value: string) => {
    setbannerState((prevState: any) => ({
      ...prevState,
      [device]: value,
    }));
  };

  const handleTextChange = (device: string, value: any) => {
    setHeadlineCustomValue((prevState: any) => ({
      ...prevState,
      [device]: value,
    }));
  };

  const handleFileUpload = (
    device: string,
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = event.target.files?.[0];
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      const fileNameWithoutExtension = file.name.replace(
        /\.(png|webp|jpg|jpeg|gif)$/i,
        "",
      );
      reader.onloadend = () => {
        setBase64Images((prevState: any) => ({
          ...prevState,
          [device]: {
            base64: reader.result as string, // Store the base64 image
            fileName: fileNameWithoutExtension, // Store the file name
          },
        }));
      };
      reader.readAsDataURL(file);
    } else {
      alert("Please upload a valid image file.");
    }
  };

  const imageUploadData = {
    data: {
      base64_image:
        uploadingDevice === "desktop"
          ? base64Images.desktop?.base64
          : uploadingDevice === "mobile"
            ? base64Images.mobile?.base64
            : base64Images.tablet?.base64,
      file_name:
        uploadingDevice === "desktop"
          ? base64Images.desktop?.fileName
          : uploadingDevice === "mobile"
            ? base64Images.mobile?.fileName
            : base64Images.tablet?.fileName,
    },
  };

  const data = {
    group_name: groupName,
    headlines: {
      mobile:
        headlineState?.mobile === "custom" ? headlineCustomValue?.mobile : null,
      tablet:
        headlineState?.tablet === "custom" ? headlineCustomValue?.tablet : null,
      desktop:
        headlineState?.desktop === "custom"
          ? headlineCustomValue?.desktop
          : null,
    },
    banners: {
      mobile: bannerState?.mobile === "inherit" ? null : bannerImagePathMobile,
      tablet: bannerState?.tablet === "inherit" ? null : bannerImagePathTablet,
      desktop:
        bannerState?.desktop === "inherit" ? null : bannerImagePathDesktop,
    },
    theme_v1_proportions: themeProportion,
    themes: themeSharedUid,
    popup_v1_proportions: popupProportion,
    popups: popupSharedUid,
  };

  const dataOfPageGroupLinks = buildFilteredPayload(
    autocompleteListCompTable,
    autocompleteList,
    buildComparisonTablesPayload,
    buildTrafficSourcesPayload,
  );

  const isCompTableValid = isComparisonTableListValid(
    autocompleteListCompTable,
  );
  const isTrafficValid = isTrafficSourceListValid(autocompleteList);

  useEffect(() => {
    const uploadImage = async () => {
      if (uploadingDevice && base64Images[uploadingDevice]?.base64) {
        try {
          setLoading(true);
          await PageGroupEndPointLogic.postImageUpload(
            token,
            selectedSharedUid,
            setImagePath,
            imageUploadData,
          );
        } catch (error) {
          console.error("Image upload failed:", error);
        } finally {
          setLoading(false);
          setBase64Images({
            desktop: null,
            mobile: null,
            tablet: null,
          });
        }
      }
    };
    uploadImage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [base64Images, uploadingDevice]);

  const handleSave = async () => {
    if (!data || currentPage !== 2) return;

    try {
      setCreationLoading(true);

      // Step 1: Edit page group first
      const editResponse = await PageGroupEndPointLogic.editPageGroup(
        token,
        selectedSharedUid,
        singlePageGroup?.shared_uid,
        data,
        () => {},
      );

      let pageGroupLinksResponse: any = null;
      let shouldCallLinks =
        hasData(dataOfPageGroupLinks.comparison_tables) ||
        hasData(dataOfPageGroupLinks.traffic_sources);

      // Step 2: If required, call pageGroupLinks
      if (shouldCallLinks) {
        try {
          pageGroupLinksResponse = await PageGroupEndPointLogic.pageGroupLinks(
            token,
            singlePageGroup?.shared_uid,
            dataOfPageGroupLinks,
          );
        } catch (error) {
          console.error("Error in pageGroupLinks:", error);
        }
      }

      // Step 3: Check conditions for closing modal and refreshing table
      const isEditSuccess = editResponse?.status === 200;
      const isLinksSuccess =
        pageGroupLinksResponse?.status === 200 || !shouldCallLinks;

      if (isEditSuccess && isLinksSuccess) {
        //  Both succeeded (or links not called)
        handleClose();
        setTableRefresh(true);
        store.dispatch(
          setDisplayErrorSnackBar({
            message: "Page Group Updation Successful",
            type: "success",
          }),
        );
        setSinglePageGroup(null);
      } else {
        // Either failed — don't close modal or refresh table
        console.warn("One of the API calls failed. Modal will remain open.");
      }
    } catch (error) {
      console.error("Error saving page group:", error);
    } finally {
      setCreationLoading(false);
    }
  };

  useEffect(() => {
    if (uploadingDevice === "desktop") {
      setBannerImagePathDesktop(imagePath);
    } else if (uploadingDevice === "mobile") {
      setBannerImagePathMobile(imagePath);
    } else {
      setBannerImagePathTablet(imagePath);
    }
    // eslint-disable-next-line
  }, [imagePath]);

  const handleCancel = () => {
    handleClose();
    setSinglePageGroup(null);
    setTimeout(() => {
      setCurrentPage(1);
    }, 500);
  };

  const handleUnlinkComparisonTable = (index: number) => {
    const updatedList = [...autocompleteListCompTable];
    const item = updatedList[index];

    // Only allow unlinking for existing items
    if (!item.isExisting) return;

    // Restore original state and mark as unlinked
    updatedList[index] = restoreOriginalState(item);

    setAutocompleteListCompTable(updatedList);
  };

  /**
   * Handle unlinking a traffic source
   * Restores original state and marks for unlinking
   */
  const handleUnlinkTrafficSource = (index: number) => {
    const updatedList = [...autocompleteList];
    const item = updatedList[index];

    // Only allow unlinking for existing items
    if (!item.isExisting) return;

    // Restore original state and mark as unlinked
    updatedList[index] = restoreOriginalState(item);

    setAutocompleteList(updatedList);
  };

  const handleRestoreComparisonTable = (index: number) => {
    const updatedList = [...autocompleteListCompTable];
    const item = updatedList[index];

    updatedList[index] = restoreUnlinkedItem(item);
    setAutocompleteListCompTable(updatedList);
  };

  /**
   * Handle restoring an unlinked traffic source
   * Restores the unlinked item back to active state
   */
  const handleRestoreTrafficSource = (index: number) => {
    const updatedList = [...autocompleteList];
    const item = updatedList[index];

    updatedList[index] = restoreUnlinkedItem(item);
    setAutocompleteList(updatedList);
  };

  /**
   * Check if comparison table at index is the first existing item
   * First existing items from backend cannot be unlinked
   */
  const isFirstExistingCompTable = (index: number) => {
    const existingItems = autocompleteListCompTable.filter(
      (item: any) => item.isExisting,
    );
    if (existingItems.length === 0) return false;
    return autocompleteListCompTable[index]?.id === existingItems[0]?.id;
  };

  /**
   * Check if traffic source at index is the first existing item
   * First existing items from backend cannot be unlinked
   */
  const isFirstExistingTrafficSource = (index: number) => {
    const existingItems = autocompleteList.filter(
      (item: any) => item.isExisting,
    );
    if (existingItems.length === 0) return false;
    return autocompleteList[index]?.id === existingItems[0]?.id;
  };

  return (
    <>
      {loadingForEditModal ? (
        <SimpleBackdrop />
      ) : (
        <>
          {loading && (
            <Dialog
              open={open}
              onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                  handleCancel();
                }
              }}
            >
              <SimpleBackdrop />
            </Dialog>
          )}
          <Dialog
            open={open}
            onClose={(_, reason) => {
              if (reason !== "backdropClick") {
                handleCancel();
              }
            }}
            fullWidth
            maxWidth="md"
          >
            <Paper sx={{ padding: "16px 24px 20px 24px" }}>
              <DialogTitle sx={{ padding: "0px 0px 4px 0px" }}>
                Edit Page Group
              </DialogTitle>
              {currentPage === 1 && (
                <>
                  <Box>
                    <Grid container>
                      <Grid size={12}>
                        <TextField
                          id="outlined-multiline-flexible"
                          label="Group Name" // Set your label here
                          placeholder="How you like the site to be called" // Set your placeholder here
                          required
                          fullWidth
                          color="secondary"
                          size="small"
                          margin="dense"
                          value={groupName}
                          error={groupName.length < 8}
                          helperText={
                            groupName.length < 8
                              ? "Group name must be at least 8 characters long"
                              : ""
                          }
                          onChange={handleInputChange} // Update state on change
                        />
                        <Typography
                          sx={{
                            fontSize: "12px",
                            marginTop: "8px",
                            color: "#00000099",
                          }}
                        >
                          minimum of 8 characters, only letters and numbers.
                        </Typography>
                      </Grid>
                    </Grid>
                    <Box mt={2} mb={2} sx={{ flexGrow: 1 }}>
                      <Typography>Themes</Typography>
                      {/* First theme field always visible */}
                      {initialTheme && initialTheme[0] && (
                        <Grid container mt={0.5}>
                          <Grid size={6}>
                            <Autocomplete
                              sx={{ width: 418, mb: 1 }}
                              value={initialTheme[0]} // Display the selected theme by its name
                              disablePortal
                              size="small"
                              options={getFilteredThemeOptions(selectedTheme2)} // Filter out the second theme from the options
                              getOptionLabel={(theme: any) => theme?.name || ""} // Display name in the dropdown
                              onChange={(_, theme: any) => {
                                setSelectedTheme1(theme); // Store the selected theme
                                const updatedList = [...initialTheme] as any;
                                updatedList[0] = {
                                  ...theme,
                                  id: updatedList[0].id,
                                  selectedValue: theme || null,
                                  shared_uid: theme?.shared_uid || null,
                                };
                                setInitialTheme(updatedList);

                                // Update restructured data
                                const restructuredThemeData = updatedList.map(
                                  (
                                    {
                                      shared_uid = "",
                                      name = "",
                                    }: {
                                      shared_uid?: string;
                                      name?: string;
                                    },
                                    index: number,
                                  ) => ({
                                    version: index + 1,
                                    shared_uid,
                                    name,
                                  }),
                                );

                                setThemeShareUid(restructuredThemeData);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Theme"
                                  required
                                  color="secondary"
                                  placeholder="Choose Page Structure Theme from the list"
                                />
                              )}
                            />
                          </Grid>
                          <Grid size={3} sx={{ pl: 1 }}>
                            <TextField
                              id="page-structure-proportion"
                              label="Proportion"
                              required
                              color="secondary"
                              size="small"
                              fullWidth
                              type="number"
                              value={themeProportion}
                              onChange={handleThemeProportionChange}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <PercentIcon />
                                  </InputAdornment>
                                ),
                                inputProps: { min: 0, max: 100 },
                              }}
                            />
                          </Grid>
                        </Grid>
                      )}

                      {/* Second theme field shown only when proportion < 100 */}
                      {showSecondTheme && initialTheme && initialTheme[1] && (
                        <Grid container mt={0.5}>
                          <Grid size={6}>
                            <Autocomplete
                              sx={{ width: 418, mb: 1 }}
                              value={initialTheme[1]} // Display the selected theme by its name
                              disablePortal
                              size="small"
                              options={getFilteredThemeOptions(selectedTheme1)} // Filter out the first theme from the options
                              getOptionLabel={(theme: any) => theme?.name || ""} // Display name in the dropdown
                              onChange={(_, theme: any) => {
                                setSelectedTheme2(theme); // Store the selected theme
                                const updatedList = [...initialTheme] as any;
                                updatedList[1] = {
                                  ...theme,
                                  id: updatedList[1]?.id || uuidv4(),
                                  selectedValue: theme || null,
                                  shared_uid: theme?.shared_uid || null,
                                };
                                setInitialTheme(updatedList);

                                // Update restructured data
                                const restructuredThemeData = updatedList.map(
                                  (
                                    {
                                      shared_uid = "",
                                      name = "",
                                    }: {
                                      shared_uid?: string;
                                      name?: string;
                                    },
                                    index: number,
                                  ) => ({
                                    version: index + 1,
                                    shared_uid,
                                    name,
                                  }),
                                );

                                setThemeShareUid(restructuredThemeData);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Theme"
                                  required
                                  color="secondary"
                                  placeholder="Choose Page Structure Theme from the list"
                                />
                              )}
                            />
                          </Grid>
                          <Grid size={3} sx={{ pl: 1 }}>
                            <TextField
                              id="page-structure-proportion-2"
                              label="Proportion"
                              required
                              color="secondary"
                              size="small"
                              fullWidth
                              value={100 - themeProportion}
                              disabled
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <PercentIcon />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Grid>
                        </Grid>
                      )}
                    </Box>
                    <Box mt={2} sx={{ flexGrow: 1 }}>
                      <Typography>Popups</Typography>
                      {initialPopup && initialPopup[0] && (
                        <Grid container mt={0.5}>
                          <Grid size={6}>
                            <Autocomplete
                              sx={{ width: 418, mb: 1 }}
                              value={initialPopup[0]} // Display the selected theme by its name
                              disablePortal
                              size="small"
                              options={getFilteredPopupOptions(selectedPopup2)} // Filter out the second theme from the options
                              getOptionLabel={(popup: any) =>
                                popup?.name || popup?.widget_name || ""
                              } // Display name in the dropdown
                              onChange={(_, popup: any) => {
                                setSelectedPopup1(popup); // Store the selected theme
                                const updatedList = [...initialPopup] as any;
                                updatedList[0] = {
                                  ...popup,
                                  id: updatedList[0].id,
                                  selectedValue: popup || null,
                                  shared_uid: popup?.shared_uid || null,
                                };
                                setInitialPopup(updatedList);

                                // Update restructured data
                                const restructuredPopupData = updatedList.map(
                                  (
                                    {
                                      shared_uid = "",
                                      widget_name = "",
                                    }: {
                                      shared_uid?: string;
                                      widget_name?: string;
                                    },
                                    index: number,
                                  ) => ({
                                    version: index + 1,
                                    shared_uid,
                                    widget_name,
                                  }),
                                );

                                setPopupShareUid(restructuredPopupData);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Popup"
                                  required
                                  color="secondary"
                                  placeholder="Choose Page Structure Popup from the list"
                                />
                              )}
                            />
                          </Grid>
                          <Grid size={3} sx={{ pl: 1 }}>
                            <TextField
                              id="page-structure-proportion"
                              label="Proportion"
                              required
                              color="secondary"
                              size="small"
                              fullWidth
                              type="number"
                              value={popupProportion}
                              onChange={handlePopupProportionChange}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <PercentIcon />
                                  </InputAdornment>
                                ),
                                inputProps: { min: 0, max: 100 },
                              }}
                            />
                          </Grid>
                        </Grid>
                      )}

                      {/* Second popup field shown only when proportion < 100 */}
                      {showSecondPopup && initialPopup && initialPopup[1] && (
                        <Grid container mt={0.5}>
                          <Grid size={6}>
                            <Autocomplete
                              sx={{ width: 418, mb: 1 }}
                              value={initialPopup[1]} // Display the selected theme by its name
                              disablePortal
                              size="small"
                              options={getFilteredPopupOptions(selectedPopup1)} // Filter out the first theme from the options
                              getOptionLabel={(popup: any) =>
                                popup?.name || popup?.widget_name || ""
                              } // Display name in the dropdown
                              onChange={(_, popup: any) => {
                                setSelectedPopup2(popup); // Store the selected theme
                                const updatedList = [...initialPopup] as any;
                                updatedList[1] = {
                                  ...popup,
                                  id: updatedList[1]?.id || uuidv4(),
                                  selectedValue: popup || null,
                                  shared_uid: popup?.shared_uid || null,
                                };
                                setInitialPopup(updatedList);

                                // Update restructured data
                                const restructuredPopupData = updatedList.map(
                                  (
                                    {
                                      shared_uid = "",
                                      widget_name = "",
                                    }: {
                                      shared_uid?: string;
                                      widget_name?: string;
                                    },
                                    index: number,
                                  ) => ({
                                    version: index + 1,
                                    shared_uid,
                                    widget_name,
                                  }),
                                );

                                setPopupShareUid(restructuredPopupData);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Popup"
                                  required
                                  color="secondary"
                                  placeholder="Choose Page Structure Popup from the list"
                                />
                              )}
                            />
                          </Grid>
                          <Grid size={3} sx={{ pl: 1 }}>
                            <TextField
                              id="page-structure-proportion-2"
                              label="Proportion"
                              required
                              color="secondary"
                              size="small"
                              fullWidth
                              value={100 - popupProportion}
                              disabled
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <PercentIcon />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Grid>
                        </Grid>
                      )}
                    </Box>
                    <Box mt={2}>
                      <Typography>Assign Comparison Tables</Typography>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Stack spacing={2} mt={0.5}>
                          {autocompleteListCompTable.length === 0 ? (
                            // When no tables exist
                            <Stack spacing={2} alignItems="flex-start">
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                No comparison tables linked. Please add some.
                              </Typography>
                              <Button
                                variant="outlined"
                                color="secondary"
                                onClick={() => {
                                  setAutocompleteListCompTable([
                                    {
                                      id: uuidv4(),
                                      selectedValue: null,
                                      shared_uid: null,
                                      isExisting: false,
                                      from_date: dayjs(),
                                      to_date: dayjs("2099-12-31"),
                                    },
                                  ]);
                                }}
                                size="small"
                              >
                                <Stack
                                  alignItems="center"
                                  flexDirection="row"
                                  gap={1}
                                >
                                  Add Table <AddIcon fontSize="small" />
                                </Stack>
                              </Button>
                            </Stack>
                          ) : (
                            <>
                              {/* Existing Comparison Table Rows */}
                              {autocompleteListCompTable.map(
                                (item: any, index: number) => (
                                  <Stack
                                    key={item.id || index}
                                    flexDirection="row"
                                    gap={1}
                                    alignItems="flex-start"
                                    flexWrap="wrap"
                                  >
                                    {/* Autocomplete for Comparison Table */}
                                    <Autocomplete
                                      disablePortal
                                      size="small"
                                      options={popUpList.filter(
                                        (popup: any) =>
                                          popup.type === "Comparison Table",
                                      )}
                                      disabled={
                                        item.isUnlinked ||
                                        (item.isExisting && !item.active)
                                      }
                                      value={
                                        item.selectedValue ||
                                        (item.table ? item : null)
                                      }
                                      getOptionLabel={(popup: any) =>
                                        popup.widget_name || popup.table || ""
                                      }
                                      onChange={(_, popup) => {
                                        const updatedList = [
                                          ...autocompleteListCompTable,
                                        ];
                                        updatedList[index] = {
                                          ...item,
                                          selectedValue: popup || null,
                                          shared_uid: popup?.shared_uid || null,
                                          table:
                                            popup?.widget_name ||
                                            popup?.table ||
                                            null,
                                        };
                                        setAutocompleteListCompTable(
                                          updatedList,
                                        );
                                      }}
                                      sx={{ width: 418 }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Comparison Table"
                                          color="secondary"
                                          placeholder="Choose Comparison Table"
                                        />
                                      )}
                                    />

                                    <DatePicker
                                      label="From Date"
                                      value={item.from_date || dayjs()}
                                      format="DD-MM-YYYY"
                                      disableFuture={false}
                                      disabled={
                                        item.isUnlinked ||
                                        (item.isExisting && !item.active)
                                      }
                                      onChange={(newValue) => {
                                        const updatedList = [
                                          ...autocompleteListCompTable,
                                        ];
                                        updatedList[index] = {
                                          ...item,
                                          from_date: newValue || dayjs(),
                                          to_date:
                                            item.to_date &&
                                            newValue &&
                                            newValue.isAfter(item.to_date)
                                              ? newValue
                                              : item.to_date,
                                        };
                                        setAutocompleteListCompTable(
                                          updatedList,
                                        );
                                      }}
                                      shouldDisableDate={(date) =>
                                        item.to_date
                                          ? date.isAfter(item.to_date, "day")
                                          : false
                                      }
                                      slotProps={{
                                        textField: {
                                          size: "small",
                                          color: "secondary",
                                          sx: { width: 150 },
                                          error: false,
                                        },
                                      }}
                                    />

                                    <DatePicker
                                      label="To Date"
                                      value={
                                        item.to_date || dayjs("2099-12-31")
                                      }
                                      format="DD-MM-YYYY"
                                      disablePast={false}
                                      disabled={
                                        item.isUnlinked ||
                                        (item.isExisting && !item.active)
                                      }
                                      onChange={(newValue) => {
                                        const updatedList = [
                                          ...autocompleteListCompTable,
                                        ];
                                        updatedList[index] = {
                                          ...item,
                                          to_date:
                                            newValue || dayjs("2099-12-31"),
                                        };
                                        setAutocompleteListCompTable(
                                          updatedList,
                                        );
                                      }}
                                      shouldDisableDate={(date) =>
                                        date.isBefore(dayjs().startOf("day")) || // disable past
                                        (item.from_date
                                          ? date.isBefore(item.from_date, "day")
                                          : false)
                                      }
                                      slotProps={{
                                        textField: {
                                          size: "small",
                                          color: "secondary",
                                          sx: { width: 150 },
                                          error: false,
                                        },
                                      }}
                                    />

                                    {/* Show unlink/restore button only for existing items that are NOT the first one */}
                                    {item.isExisting &&
                                      !isFirstExistingCompTable(index) &&
                                      item.active && (
                                        <>
                                          {!item.isUnlinked ? (
                                            <IconButton
                                              color="error"
                                              size="small"
                                              onClick={() =>
                                                setConfirmDialog({
                                                  open: true,
                                                  type: "table",
                                                  index,
                                                })
                                              }
                                            >
                                              <Tooltip title="Unlink">
                                                <ClearIcon />
                                              </Tooltip>
                                            </IconButton>
                                          ) : (
                                            <IconButton
                                              color="success"
                                              size="small"
                                              onClick={() =>
                                                handleRestoreComparisonTable(
                                                  index,
                                                )
                                              }
                                            >
                                              <Tooltip title="Restore">
                                                <RestoreIcon color="secondary" />
                                              </Tooltip>
                                            </IconButton>
                                          )}
                                        </>
                                      )}

                                    {/* Show clear button only for newly added items */}
                                    {!item.isExisting && (
                                      <Stack
                                        alignItems="center"
                                        flexDirection="row"
                                        gap={1}
                                      >
                                        <IconButton
                                          color="secondary"
                                          size="small"
                                          onClick={() => {
                                            const updatedList =
                                              autocompleteListCompTable.filter(
                                                (_: any, idx: any) =>
                                                  idx !== index,
                                              );
                                            setAutocompleteListCompTable(
                                              updatedList,
                                            );
                                          }}
                                        >
                                          <ClearIcon />
                                        </IconButton>
                                      </Stack>
                                    )}
                                  </Stack>
                                ),
                              )}

                              {/* Helper text + Add Another button below all rows */}
                              <Stack alignItems="flex-start">
                                <FormHelperText sx={{ mb: 0.5 }}>
                                  More than one linked asset?
                                </FormHelperText>
                                <Button
                                  variant="outlined"
                                  size="small"
                                  color="secondary"
                                  onClick={() => {
                                    const updatedList = [
                                      ...autocompleteListCompTable,
                                      {
                                        id: uuidv4(),
                                        selectedValue: null,
                                        shared_uid: null,
                                        isExisting: false,
                                        from_date: dayjs(),
                                        to_date: dayjs("2099-12-31"),
                                      },
                                    ];
                                    setAutocompleteListCompTable(updatedList);
                                  }}
                                >
                                  <Stack
                                    alignItems="center"
                                    flexDirection="row"
                                    gap={1}
                                  >
                                    Add Another <AddIcon fontSize="small" />
                                  </Stack>
                                </Button>
                              </Stack>
                            </>
                          )}
                        </Stack>
                      </LocalizationProvider>
                    </Box>

                    <Box mt={2}>
                      <Typography>Assign Traffic Source *</Typography>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Stack spacing={2} mt={0.5}>
                          {autocompleteList.length === 0 ? (
                            // Show message when no traffic sources exist
                            <Stack spacing={2} alignItems="flex-start">
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                No traffic sources linked. Please add some.
                              </Typography>
                              <Button
                                variant="outlined"
                                color="secondary"
                                onClick={() => {
                                  setAutocompleteList([
                                    {
                                      id: uuidv4(),
                                      selectedValue: null,
                                      shared_uid: null,
                                      isExisting: false,
                                      from_date: dayjs(),
                                      to_date: dayjs("2099-12-31"),
                                    },
                                  ]);
                                }}
                                size="small"
                              >
                                <Stack
                                  alignItems="center"
                                  flexDirection="row"
                                  gap={1}
                                >
                                  Add Source <AddIcon fontSize="small" />
                                </Stack>
                              </Button>
                            </Stack>
                          ) : (
                            <>
                              {/* Existing Traffic Source Rows */}
                              {autocompleteList.map(
                                (item: any, index: number) => (
                                  <Stack
                                    key={item.id || index}
                                    flexDirection="row"
                                    gap={1}
                                    alignItems="flex-start"
                                    flexWrap="wrap"
                                  >
                                    {/* Traffic Source Autocomplete */}
                                    <Autocomplete
                                      disablePortal
                                      size="small"
                                      options={trafficSources.filter(
                                        (source: any) =>
                                          source.active !== false,
                                      )}
                                      disabled={
                                        item.isUnlinked ||
                                        (item.isExisting && !item.active)
                                      }
                                      value={
                                        item.selectedValue ||
                                        (item.source ? item : null)
                                      }
                                      getOptionLabel={(source: any) =>
                                        source.traffic_source_name ||
                                        source.source ||
                                        ""
                                      }
                                      onChange={(_, source) => {
                                        const updatedList = [
                                          ...autocompleteList,
                                        ];
                                        updatedList[index] = {
                                          ...item,
                                          selectedValue: source || null,
                                          shared_uid: source?.shared_uid || "",
                                          source:
                                            source?.traffic_source_name ||
                                            source?.source ||
                                            null,
                                        };
                                        setAutocompleteList(updatedList);
                                      }}
                                      sx={{ width: 418 }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Traffic Source"
                                          required
                                          color="secondary"
                                          placeholder="Choose Traffic Source"
                                        />
                                      )}
                                    />

                                    {/* From Date */}
                                    <DatePicker
                                      label="From Date"
                                      value={item.from_date || dayjs()}
                                      format="DD-MM-YYYY"
                                      disabled={
                                        item.isUnlinked ||
                                        (item.isExisting && !item.active)
                                      }
                                      onChange={(newValue) => {
                                        const updatedList = [
                                          ...autocompleteList,
                                        ];
                                        updatedList[index] = {
                                          ...item,
                                          from_date: newValue || dayjs(),
                                          to_date:
                                            item.to_date &&
                                            newValue &&
                                            newValue.isAfter(item.to_date)
                                              ? newValue
                                              : item.to_date,
                                        };
                                        setAutocompleteList(updatedList);
                                      }}
                                      shouldDisableDate={(date) =>
                                        item.to_date
                                          ? date.isAfter(item.to_date, "day")
                                          : false
                                      }
                                      slotProps={{
                                        textField: {
                                          size: "small",
                                          color: "secondary",
                                          sx: { width: 150 },
                                        },
                                      }}
                                    />

                                    {/* To Date */}
                                    <DatePicker
                                      label="To Date"
                                      value={
                                        item.to_date || dayjs("2099-12-31")
                                      }
                                      format="DD-MM-YYYY"
                                      disabled={
                                        item.isUnlinked ||
                                        (item.isExisting && !item.active)
                                      }
                                      onChange={(newValue) => {
                                        const updatedList = [
                                          ...autocompleteList,
                                        ];
                                        updatedList[index] = {
                                          ...item,
                                          to_date:
                                            newValue || dayjs("2099-12-31"),
                                        };
                                        setAutocompleteList(updatedList);
                                      }}
                                      shouldDisableDate={(date) =>
                                        // date.isBefore(dayjs().startOf("day")) || // disable past
                                        item.from_date
                                          ? date.isBefore(item.from_date, "day")
                                          : false
                                      }
                                      slotProps={{
                                        textField: {
                                          size: "small",
                                          color: "secondary",
                                          sx: { width: 150 },
                                        },
                                      }}
                                    />

                                    {/* Show unlink/restore button only for existing items that are NOT the first one */}
                                    {item.isExisting &&
                                      !isFirstExistingTrafficSource(index) &&
                                      item.active && (
                                        <>
                                          {!item.isUnlinked ? (
                                            <IconButton
                                              color="error"
                                              size="small"
                                              onClick={() =>
                                                setConfirmDialog({
                                                  open: true,
                                                  type: "source",
                                                  index,
                                                })
                                              }
                                            >
                                              <Tooltip title="Unlink">
                                                <ClearIcon />
                                              </Tooltip>
                                            </IconButton>
                                          ) : (
                                            <IconButton
                                              color="success"
                                              size="small"
                                              onClick={() =>
                                                handleRestoreTrafficSource(
                                                  index,
                                                )
                                              }
                                            >
                                              <Tooltip title="Restore">
                                                <RestoreIcon color="secondary" />
                                              </Tooltip>
                                            </IconButton>
                                          )}
                                        </>
                                      )}

                                    {/* Show clear button only for newly added items */}
                                    {!item.isExisting && (
                                      <Stack
                                        alignItems="center"
                                        flexDirection="row"
                                        gap={1}
                                      >
                                        <IconButton
                                          color="secondary"
                                          size="small"
                                          onClick={() => {
                                            const updatedList =
                                              autocompleteList.filter(
                                                (_: any, idx: any) =>
                                                  idx !== index,
                                              );
                                            setAutocompleteList(updatedList);
                                          }}
                                        >
                                          <ClearIcon />
                                        </IconButton>
                                      </Stack>
                                    )}
                                  </Stack>
                                ),
                              )}

                              {/* Helper text + Add Another button BELOW all items */}
                              <Stack alignItems="flex-start">
                                <FormHelperText sx={{ mb: 0.5 }}>
                                  More than one linked asset?
                                </FormHelperText>
                                <Button
                                  variant="outlined"
                                  color="secondary"
                                  size="small"
                                  onClick={() => {
                                    const updatedList = [
                                      ...autocompleteList,
                                      {
                                        id: uuidv4(),
                                        selectedValue: null,
                                        shared_uid: null,
                                        isExisting: false,
                                        from_date: dayjs(),
                                        to_date: dayjs("2099-12-31"),
                                      },
                                    ];
                                    setAutocompleteList(updatedList);
                                  }}
                                >
                                  <Stack
                                    alignItems="center"
                                    flexDirection="row"
                                    gap={1}
                                  >
                                    Add Another <AddIcon fontSize="small" />
                                  </Stack>
                                </Button>
                              </Stack>
                            </>
                          )}
                        </Stack>
                      </LocalizationProvider>
                    </Box>

                    <Typography
                      sx={{
                        fontSize: "12px",
                        marginTop: "8px",
                        color: "#00000099",
                      }}
                    >
                      Fields marked with * are mandatory.
                    </Typography>
                  </Box>
                  <Box>
                    <Stack
                      flexDirection={"row"}
                      justifyContent={"end"}
                      marginTop={2}
                      gap={1}
                    >
                      <Button color="secondary" onClick={handleClose}>
                        CANCEL
                      </Button>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleNext}
                        //don't modify the disabled logic without proper KT
                        disabled={
                          groupName.length <= 7 ||
                          !initialPopup ||
                          !initialTheme ||
                          //@ts-ignore
                          initialPopup[0]?.selectedValue === null ||
                          (showSecondPopup &&
                            //@ts-ignore
                            initialPopup[0]?.selectedValue === null) ||
                          (showSecondPopup &&
                            initialPopup[1] &&
                            //@ts-ignore
                            (initialPopup[1]?.name === null ||
                              //@ts-ignore
                              initialPopup[1]?.name === "" ||
                              //@ts-ignore
                              initialPopup[1]?.selectedValue === null)) || // Check if second popup is shown and second popup name is empty
                          //@ts-ignore
                          !initialTheme[0]?.name || // Check if first theme name is empty
                          //@ts-ignore
                          (showSecondTheme &&
                            initialTheme[1] &&
                            //@ts-ignore
                            !initialTheme[1]?.name) || // Check if second theme is shown and second theme name is empty
                          !popupProportion ||
                          !themeProportion ||
                          !isCompTableValid ||
                          !isTrafficValid ||
                          autocompleteList.length === 0
                        }
                      >
                        <Stack flexDirection={"row"}>
                          Next <ChevronRightIcon />
                        </Stack>
                      </Button>
                    </Stack>
                  </Box>
                </>
              )}

              {/* next page of the create pop-up */}
              {currentPage === 2 && (
                <>
                  <Box>
                    <Grid container>
                      <Grid size={12}>
                        <Typography variant="h6">Second Headline:</Typography>
                      </Grid>

                      {/* Headline sections for Desktop, Mobile, and Tablet */}
                      {["desktop", "mobile", "tablet"].map((device) => (
                        <React.Fragment key={device}>
                          <Grid size={12} mt={1}>
                            <Typography variant="subtitle1">
                              {device.charAt(0).toUpperCase() + device.slice(1)}
                              :
                            </Typography>
                          </Grid>
                          <Grid size={4}>
                            <Stack gap={3} flexDirection={"row"}>
                              <RadioGroup defaultValue="website">
                                <Stack
                                  direction="row"
                                  alignItems="center"
                                  spacing={1}
                                >
                                  <Radio
                                    value="website"
                                    sx={{
                                      color: "#9C27B0", // Purple color
                                      "&.Mui-checked": { color: "#9C27B0" },
                                    }}
                                    onClick={() =>
                                      handleHeadlineChange(device, "inherit")
                                    }
                                    checked={
                                      headlineState[device] === "inherit"
                                    }
                                  />
                                  <Stack>
                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                    >
                                      Inherit From
                                    </Typography>
                                    <Typography
                                      fontSize={16}
                                      fontWeight={400}
                                      height={20}
                                    >
                                      Website
                                    </Typography>
                                  </Stack>
                                </Stack>
                              </RadioGroup>
                              <RadioGroup defaultValue="website">
                                <Stack
                                  direction="row"
                                  alignItems="center"
                                  spacing={1}
                                >
                                  <Stack>
                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                    >
                                      Headline
                                    </Typography>
                                    <Typography
                                      fontSize={16}
                                      fontWeight={400}
                                      height={20}
                                    >
                                      N/A
                                    </Typography>
                                  </Stack>
                                </Stack>
                              </RadioGroup>
                            </Stack>
                          </Grid>
                          {/* Custom Option */}
                          <Grid size={8}>
                            <Stack flexDirection={"row"}>
                              <FormControlLabel
                                value={`custom-${device}`}
                                control={<Radio color="secondary" />}
                                label="Custom:"
                                onClick={() =>
                                  handleHeadlineChange(device, "custom")
                                }
                                checked={headlineState[device] === "custom"}
                              />
                              <TextField
                                id={`custom-headline-${device}`}
                                label="Custom Headline"
                                placeholder={`New ${device} headline`}
                                onChange={(e) =>
                                  handleTextChange(device, e.target.value)
                                }
                                fullWidth
                                color="secondary"
                                size="small"
                                disabled={headlineState[device] === "inherit"}
                                value={
                                  headlineState[device] === "custom"
                                    ? headlineCustomValue[device]
                                    : ""
                                }
                              />
                            </Stack>
                          </Grid>
                        </React.Fragment>
                      ))}

                      {/* Banner Image Section */}
                      <Grid size={12} mt={2}>
                        <Typography variant="h6">Banner Image:</Typography>
                      </Grid>

                      {["desktop", "mobile", "tablet"].map((device: any) => {
                        const isImageUploaded =
                          device === "desktop"
                            ? bannerImagePathDesktop
                            : device === "mobile"
                              ? bannerImagePathMobile
                              : bannerImagePathTablet;

                        return (
                          <React.Fragment key={device}>
                            <Grid
                              container
                              mt={1}
                              alignItems="center"
                              size={12}
                            >
                              <Typography variant="subtitle1">
                                {device.charAt(0).toUpperCase() +
                                  device.slice(1)}
                                :
                              </Typography>
                            </Grid>
                            {/* Inherit option for banner images  */}
                            <Grid size={4}>
                              <Stack
                                direction="row"
                                alignItems="center"
                                gap={3}
                                mt={1}
                              >
                                <RadioGroup defaultValue="website">
                                  <Stack
                                    direction="row"
                                    alignItems="center"
                                    spacing={1}
                                  >
                                    <Radio
                                      value="website"
                                      sx={{
                                        color: "#9C27B0", // Purple color
                                        "&.Mui-checked": { color: "#9C27B0" },
                                      }}
                                      onClick={() =>
                                        handleBannerChange(device, "inherit")
                                      }
                                      checked={
                                        bannerState[device] === "inherit"
                                      }
                                    />
                                    <Stack>
                                      <Typography
                                        variant="body2"
                                        color="text.secondary"
                                      >
                                        Inherit From
                                      </Typography>
                                      <Typography
                                        fontSize={16}
                                        fontWeight={400}
                                        height={20}
                                      >
                                        Website
                                      </Typography>
                                    </Stack>
                                  </Stack>
                                </RadioGroup>
                                <RadioGroup defaultValue="website">
                                  <Stack
                                    direction="row"
                                    alignItems="center"
                                    spacing={1}
                                  >
                                    <Stack>
                                      <Typography
                                        variant="body2"
                                        color="text.secondary"
                                      >
                                        Banner
                                      </Typography>
                                      <Typography
                                        fontSize={16}
                                        fontWeight={400}
                                        height={20}
                                      >
                                        N/A
                                      </Typography>
                                    </Stack>
                                  </Stack>
                                </RadioGroup>
                              </Stack>
                            </Grid>
                            {/* custom banner images  */}
                            <Grid size={8}>
                              <Stack flexDirection="row" alignItems="center">
                                <FormControlLabel
                                  value={`custom-${device}`}
                                  control={<Radio color="secondary" />}
                                  label="Custom:"
                                  onClick={() =>
                                    handleBannerChange(device, "custom")
                                  }
                                  checked={bannerState[device] === "custom"}
                                />

                                <TextField
                                  id={`custom-headline-${device}`}
                                  placeholder={`New ${device} Banner`}
                                  onChange={(e) =>
                                    handleTextChange(device, e.target.value)
                                  }
                                  fullWidth
                                  color="secondary"
                                  size="small"
                                  value={isImageUploaded}
                                  disabled
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        {!isImageUploaded ? (
                                          <>
                                            <input
                                              aria-label="upload picture"
                                              accept="image/*"
                                              style={{ display: "none" }}
                                              id={`file-upload-${device}`}
                                              type="file"
                                              onChange={(e) => {
                                                setUploadingDevice(device);
                                                handleFileUpload(device, e);
                                              }}
                                              disabled={
                                                bannerState[device] ===
                                                "inherit"
                                              }
                                            />
                                            <label
                                              htmlFor={`file-upload-${device}`}
                                            >
                                              <IconButton
                                                disabled={
                                                  bannerState[device] ===
                                                  "inherit"
                                                }
                                                component="span"
                                              >
                                                <FileUploadOutlinedIcon
                                                  color={
                                                    bannerState[device] ===
                                                    "inherit"
                                                      ? "disabled"
                                                      : "secondary"
                                                  }
                                                />
                                              </IconButton>
                                            </label>
                                          </>
                                        ) : (
                                          <IconButton
                                            onClick={() => {
                                              if (device === "desktop")
                                                setBannerImagePathDesktop("");
                                              if (device === "mobile")
                                                setBannerImagePathMobile("");
                                              if (device === "tablet")
                                                setBannerImagePathTablet("");
                                            }}
                                          >
                                            <ClearIcon color="secondary" />
                                          </IconButton>
                                        )}
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </Stack>
                            </Grid>
                          </React.Fragment>
                        );
                      })}
                    </Grid>

                    <Stack
                      flexDirection={"row"}
                      justifyContent={"end"}
                      marginTop={2}
                      gap={1}
                    >
                      <Button color="secondary" onClick={handleCancel}>
                        CANCEL
                      </Button>
                      <Button
                        color="secondary"
                        onClick={handleBack}
                        variant="outlined"
                      >
                        <Stack flexDirection={"row"} gap={1}>
                          <KeyboardArrowLeftIcon /> BACK
                        </Stack>
                      </Button>
                      <Button
                        data-tracker="35"
                        color="secondary"
                        variant="contained"
                        onClick={handleSave} // Use the new handler directly
                        disabled={creationLoading}
                      >
                        <Stack
                          flexDirection={"row"}
                          gap={1}
                          alignItems="center"
                        >
                          {creationLoading ? (
                            <>
                              Save{" "}
                              <CircularProgress size={20} color="inherit" />
                            </>
                          ) : (
                            <>
                              Save <SaveIcon />
                            </>
                          )}
                        </Stack>
                      </Button>
                    </Stack>
                  </Box>
                </>
              )}
            </Paper>
          </Dialog>
          <ConfirmDialog
            open={confirmDialog.open}
            title={`Unlink ${
              confirmDialog.type === "table"
                ? "Comparison Table"
                : "Traffic Source"
            }`}
            message={`Are you sure you want to unlink this ${
              confirmDialog.type === "table"
                ? "comparison table"
                : "traffic source"
            }?`}
            confirmText="Unlink"
            cancelText="Cancel"
            confirmColor="error"
            onCancel={() =>
              setConfirmDialog({ open: false, type: "", index: null })
            }
            onConfirm={() => {
              if (
                confirmDialog.type === "table" &&
                confirmDialog.index !== null
              ) {
                handleUnlinkComparisonTable(confirmDialog.index);
              } else if (
                confirmDialog.type === "source" &&
                confirmDialog.index !== null
              ) {
                handleUnlinkTrafficSource(confirmDialog.index);
              }
              setConfirmDialog({ open: false, type: "", index: null });
            }}
          />
        </>
      )}
    </>
  );
}

export default EditNewRequestModal;
